var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.zoom < 14)?_c('vl-layer-vector',{attrs:{"id":"projectPoints"}},[_c('vl-source-vector',{attrs:{"features":_vm.geojson.features}}),_c('vl-style-func',{attrs:{"factory":_vm.makeClusterStyleFunc}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }